import UtilsSchema from "@repoflow/schema/utils";

const email = { $ref: "/Email" };

// A password being *set*, so the strength policy applies. /Password is
// minLength: 8 and lives in @repoflow/schema.
const password = { $ref: "/Password" };
const confirm = { $ref: "/Password" };

// A password being *presented* — at sign-in, or as the current one on the way to
// changing it. Deliberately not /Password: the policy governs what a password
// may become, not what an existing one already is. Enforcing minLength here
// checks the wrong thing at the wrong time, and it fails closed in the worst
// way — raise /Password to 10 and every account still holding an 8-character
// password is locked out of the login form, and out of the change-password form
// that is the one place they could fix it. Non-empty is the real requirement;
// whether it is correct is the server's answer to give.
const existing = { type: "string", minLength: 1 };

export default [
  ...UtilsSchema,
  {
    id: "/Input/Login/UI",
    type: "object",
    properties: {
      email,
      password: existing,
    },
    required: ["email", "password"],
  },
  {
    id: "/Input/Register/UI",
    type: "object",
    properties: {
      email,
      terms: {
        type: "boolean",
        const: true,
      },
    },
    required: ["email", "terms"],
  },
  {
    id: "/Input/Attach/UI",
    type: "object",
    properties: {
      password,
      confirm,
    },
    required: ["password", "confirm"],
  },
  {
    id: "/Input/Password/Update",
    type: "object",
    properties: {
      current: existing,
      password,
      confirm,
    },
    required: ["current", "password", "confirm"],
  },
  {
    // The "forgot your password" form. Just an address — the domain comes from
    // the query string, as it does on login.
    id: "/Input/Reset/Request/UI",
    type: "object",
    properties: {
      email,
    },
    required: ["email"],
  },
  {
    // What the reset form collects. `confirm` is a UI concern — JSON Schema
    // cannot say "equal to another property", so the match is checked in the
    // form and never reaches the API.
    id: "/Input/Reset/UI",
    type: "object",
    properties: {
      password,
      confirm,
    },
    required: ["password", "confirm"],
  },
  {
    // What the API is actually sent, and what the resolver validates before it
    // writes. /Input/Attach/UI is not reused for this: it requires `confirm`,
    // which the mutation does not carry, so validating against it would reject
    // every well-formed request.
    id: "/Input/Reset",
    type: "object",
    properties: {
      password,
    },
    required: ["password"],
  },

];
